import { createContext } from "react";
import { contactFormType } from "../types/types";

export const contactFormContext = createContext<contactFormType>({} as contactFormType);